import { lazy } from 'react';

let deploy = {};
const modules = import.meta.globEager('../ymls/*.yml');
const company = import.meta.env.VITE_APP_PRIVATE;
Object.keys(modules).forEach((el) => {
  if (el.includes(company)) {
    deploy = modules[el].default;
  }
});
const { global } = deploy;

/**
 * 微信看版
 */
const wechatDashBoard = [
  {
    path: 'bulletinBoard', // 新版数据看板
    component: lazy(() => import('@/pages/bulletinBoard/index')),
  },
  {
    path: '/dashboard',
    class: true,
    component: lazy(() => import('@/pages/wechat-viewing/wechat-dashboard/index')),
  },
  {
    path: '/ailogs',
    class: true,
    component: lazy(() => import('@/pages/ailogs/index')),
  },
  {
    path: '/dashboardlist',
    class: true,
    component: lazy(() => import('@/pages/wechat-viewing/wechat-dashboard/statisticsList')),
  },
  {
    path: '/callstatistics',
    class: true,
    component: lazy(() => import(global?.wechatStatistics
      ? '@/pages/wechat-viewing/wechat-callStatistics/index'
      : '@/pages/wechat-viewing/wechat-oldCallStatistics/index')),
  },
  {
    path: '/callstatistics/callStatisticsDetail',
    class: true,
    component: lazy(() => import('@/pages/wechat-viewing/wechat-oldCallStatistics/detail')),
  },
];

/**
 * 微信管理
 */
const wechatManagement = [
  {
    path: '/wechatList',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatlist')),
  },
  {
    path: '/longVoiceMatching',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/longVoiceMatching')),
  },
  {
    name: '微信详情',
    path: '/wechatList/wechatdetail/:type/:id',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatdetail')),
  },
  {
    name: '微信详情',
    path: '/departure/wechatdetail/:type/:id',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatdetail')),
  },
  {
    path: '/friendlist',
    class: true,
    component: lazy(() => import('@/pages/wechat-manage/friendlist')),
  },
  {
    path: '/voice-call-list',
    class: true,
    component: lazy(() => import(global?.wechatCallRevision
      ? '@/pages/wechat-manage/voice-call-list'
      : '@/pages/wechat-manage/old-voice-call-list')),
  },
  {
    path: '/wechatgroup',
    class: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatgroup')),
  },
  {
    path: '/refriend',
    class: true,
    component: lazy(() => import('@/pages/wechat-manage/refriend')),
  },
  {
    path: '/validationMessage',
    class: true,
    component: lazy(() => import('@/pages/wechat-manage/validationMessage/index')),
  },
  {
    path: '/departure',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatlist')),
  },
  {
    path: '/custmer',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/wechat-manage/friendlist')),
  },
];

/**
 * 微信风控
 */
const wechaRiskManagement = [
  {
    path: '/financial',
    class: true,
    component: lazy(() => import('@/pages/wechat-risk-management/finacial/index')),
  },
  {
    path: '/sensitiveaction',
    class: true,
    component: lazy(() => import('@/pages/wechat-risk-management/sensitiveaction/index')),
  },
  {
    path: '/sensitivestatistics',
    class: true,
    component: lazy(() => import(global?.sensitiveRevision
      ? '@/pages/wechat-risk-management/sensitivestatistics/index'
      : '@/pages/wechat-risk-management/sensitivestatistics/oldIndex')),
  },
  {
    path: '/sensitivesetting',
    class: true,
    component: lazy(() => import(global?.sensitiveRevision
      ? '@/pages/wechat-risk-management/sensitivesetting/index'
      : '@/pages/wechat-risk-management/sensitivesetting/oldIndex')),
  },
  {
    path: '/WechatLoginLog',
    class: true,
    component: lazy(() => import('@/pages/wechat-risk-management/wechatLoginLog/index')),
  },
  {
    path: '/delmsgstatis',
    class: true,
    component: lazy(() => import('@/pages/wechat-risk-management/delmsgstatis/index')),
  },
  {
    path: '/repeatedgroup',
    class: true,
    component: lazy(() => import('@/pages/wechat-risk-management/repeatedgroupstatistics/index')),
  },
];

/**
 *辅助营销
 */
const wechatMarketing = [
  {
    path: '/livecode',
    class: true,
    component: lazy(() => import('@/pages/wechat-marketing/livecode/index')),
  },
  {
    path: '/livecodeadd',
    class: true,
    component: lazy(() => import('@/pages/wechat-marketing/livecode/add')),
  },
];

/**
 * 微信设置
 */
const wechatSetting = [
  {
    path: '/setting/setupignore',
    class: true,
    component: lazy(() => import('@/pages/wechat-setting/setupIgnore')),
  },
  {
    path: '/setting/examination',
    class: true,
    component: lazy(() => import('@/pages/wechat-setting/examination')),
  },
  {
    path: '/setting/automatictagging',
    class: true,
    component: lazy(() => import('@/pages/wechat-setting/automatictagging')),
  },
  {
    path: '/setting/frequency',
    class: true,
    component: lazy(() => import('@/pages/wechat-setting/frequency')),
  },
];

/**
 *  聊天记录
 */

const messageList = [
  {
    name: '聊天记录',
    path: 'message',
    component: lazy(() => import('@/pages/wechat-record/components/message')),
    children: [
      {
        path: 'wechat-window/:isGroup/:wechatId/:friendId',
        component: lazy(() => import('@/pages/wechat-record/components/chatwindow')),
      },
      {
        path: 'wechat-window/:isGroup/:wechatId/:friendId/:aiModal',
        component: lazy(() => import('@/pages/wechat-record/components/chatwindow')),
      },
    ],
  },
  {
    name: '统计分析',
    path: 'statistic/:wechatId',
    class: true,
    component: lazy(() => import('@/pages/wechat-record/components/statistics')),
  },
  {
    name: '微信详情',
    path: 'wechatList/wechatdetail/:tab/:id/:wechatId',
    class: true,
    component: lazy(() => import('@/pages/wechat-manage/wechatdetail')),
  },

  // {
  //   name: '新的客户',
  //   path: 'customer/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table1')),
  // },
  // {
  //   name: '新的群',
  //   path: 'group/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table2')),
  // },
  // {
  //   name: '红包转账',
  //   path: 'envelopes/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table3')),
  // },
  // {
  //   name: '敏感词',
  //   path: 'sensitiveWords/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table4')),
  // },
  // {
  //   name: '删除客户',
  //   path: 'deleteCutsomer/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table5')),
  // },
  // {
  //   name: '拉黑客户',
  //   path: 'blockCustomer/:wechatId',
  //   class: true,
  //   component: lazy(() => import('@/pages/wechat-record/components/table6')),
  // },
  {
    name: '查看朋友圈',
    path: 'friendcicle/:wechatId',
    class: true,
    component: lazy(() => import('@/pages/wechat-record/components/friendcicle')),
  },
  // {
  //   name: '语音通话',
  //   path: 'voidCall/:wechatId',
  //   class: true,
  //   component: lazy(() => import(global?.wechatCallRevision
  //     ? '@/pages/wechat-record/components/table8'
  //     : '@/pages/wechat-record/components/oldTable8')),
  // },
];

/**
 * 微名片
 */
const cloudcard = [
  {
    path: '/cloudcard/statistics',
    class: true,
    component: lazy(() => import('@/pages/cloudcard/statistics')),
  },
  {
    path: '/cloudcard/cardmanage',
    class: true,
    component: lazy(() => import('@/pages/cloudcard/cardmanage')),
  },
  {
    path: '/cloudcard/customerlist',
    class: true,
    component: lazy(() => import('@/pages/cloudcard/customer')),
  },
];

/**
 * qq
 */
const qqList = [
  {
    path: '/qqlist',
    class: true,
    component: lazy(() => import('@/pages/qq/qqList')),
  },
  {
    path: '/qqlist/qqdetail/:type/:name/:qq',
    class: true,
    component: lazy(() => import('@/pages/qq/qqDetail')),
  },
  {
    path: '/qqVoiceCallList',
    class: true,
    component: lazy(() => import('@/pages/qq/qqVoiceCallList')),
  },
  {
    path: '/qqSensitivesetting',
    class: true,
    component: lazy(() => import('@/pages/qq/sensitivesetting')),
  },
  {
    path: '/qqSensitivestatistics',
    class: true,
    component: lazy(() => import('@/pages/qq/sensitivestatistics')),
  },
];

/**
 * 抖音
 */
const dyList = [
  {
    path: '/saledouyin',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/douyin/saleslist')),
  },
  {
    path: '/cusdouyin',
    class: true,
    component: lazy(() => import('@/pages/douyin/customelist')),
  },
  {
    path: '/saledouyin/dydetail/:userName/:tikTokName/:userId',
    class: true,
    component: lazy(() => import('@/pages/douyin/salesCustomes')),
  },
  {
    path: '/dysensitiveword',
    class: true,
    component: lazy(() => import('@/pages/douyin/sensitivStatic')),
  },
  {
    path: '/dysensitivesetting',
    class: true,
    component: lazy(() => import('@/pages/douyin/sensitivSetting')),
  },
  {
    path: '/chatroom/:hasmenu/:tikTokId/:customerTikTokId/:userId/:start',
    class: true,
    component: lazy(() => import('@/pages/douyin/chatRoom')),
  },
  {
    path: '/customerRetention',
    class: true,
    component: lazy(() => import('@/pages/douyin/customerRetention/index')),
  },
];

const ykQwList = [
  {
    name: '企业微信管理',
    path: 'ykQw/enterprisemanage',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-wechat-manage')),
  },
  {
    name: '企业微信客户列表',
    path: 'ykQw/customerList',
    key: 'CustomerList',
    class: true,
    component: lazy(() => import('@/pages/qw/enterpise-customer/index')),
  },
  {
    name: '企业微信群统计',
    path: 'ykQw/groupStatistics',
    key: 'groupStatistics',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-Groupstatistics/index')),
  },
  {
    name: '语音通话',
    path: 'ykQw/voiceList',
    class: true,
    component: lazy(() => import('@/pages/qw/enterpiseVoicelist')),
  },
  {
    name: '敏感词设置',
    path: 'ykQw/sensitivesetting',
    class: true,
    component: lazy(() => import('@/pages/qw/sensitivesetting')),
  },
  {
    name: '敏感词统计',
    path: 'ykQw/sensitivestatistics',
    class: true,
    component: lazy(() => import('@/pages/qw/sensitivestatistics')),
  },
];

const qwList = [
  {
    name: '企业微信管理',
    path: 'qw/enterprisemanage',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-wechat-manage')),
  },
  {
    name: '企业绑定信息',
    path: 'qw/businessBinding',
    component: lazy(() => import('@/pages/qw/enterprise-business-binding/list')),
  },
  {
    name: '企业微信看板',
    path: 'qw/wechatChart',
    class: true,
    component: lazy(() => import('@/pages/qw/wechat-Chart/index')),
  },
  {
    name: '企业微信敏感词设置',
    path: 'qw/settingSensitive',
    class: true,
    component: lazy(() => import('@/pages/qw/Sensitive-words/settingSensitive')),
  },
  {
    name: '企业微信敏感词统计',
    path: 'qw/SensitiveStatistics',
    class: true,
    component: lazy(() => import('@/pages/qw/Sensitive-words/SetsitiveStatistics')),
  },
  {
    name: '企业微信敏感词操作统计',
    path: 'qw/SensitiveOperation',
    class: true,
    component: lazy(() => import('@/pages/qw/Sensitive-words/SensitiveOperation')),
  },
  {
    name: '企业微信客户列表',
    path: 'qw/customerList',
    key: 'CustomerList',
    class: true,
    component: lazy(() => import('@/pages/qw/enterpise-customer/index')),
  },
  {
    name: '企业微信群统计',
    path: 'qw/groupStatistics',
    key: 'groupStatistics',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-Groupstatistics/index')),
  },
  {
    name: '企业微信活码',
    path: 'qw/enterpiseLiceCode',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-liveCode/index')),
  },
  {
    name: '新建活码',
    path: 'qw/AddQrcode',
    class: true,
    component: lazy(() => import('@/pages/qw/enterprise-liveCode/AddQrCode')),
  },
  {
    name: '欢迎语设置',
    path: 'qw/welcomeMessageSetting',
    class: true,
    component: lazy(() => import('@/pages/qw/welcome-message/index')),
  },
  {
    name: '语音通话',
    path: 'qw/voiceList',
    class: true,
    component: lazy(() => import('@/pages/qw/enterpiseVoicelist')),
  },
  {
    name: '流失客户',
    path: 'qw/drainCustomer',
    class: true,
    component: lazy(() => import('@/pages/qw/DrainCustomer')),
  },
  {
    name: '聊天标签',
    path: 'qw/chatTagSettings',
    class: true,
    component: lazy(() => import('@/pages/qw/chatTagSettings')),
  },
  {
    name: '添加好友',
    path: 'qw/addFriends',
    component: lazy(() => import('@/pages/qw/addFriends')),
  },
  {
    name: '离职继承',
    path: 'qw/resignInherit',
    class: true,
    component: lazy(() => import('@/pages/qw/resignInherit')),
  },
  {
    name: '个人SOP',
    path: 'qw/personalSOP',
    class: true,
    component: lazy(() => import('@/pages/qw/personalSOP/index')),
  },
  {
    name: '分配记录',
    path: 'qw/excitation',
    class: true,
    component: lazy(() => import('@/pages/qw/resignInherit/excitation')),
  },
  {
    name: '/在职转接',
    path: 'qw/workTransfer',
    class: true,
    component: lazy(() => import('@/pages/qw/Transfer/index')),
  },
  {
    name: '在职转接-分配记录',
    path: 'qw/workAllotRecord',
    class: true,
    component: lazy(() => import('@/pages/qw/Transfer/workAllotRecord')),
  },
  {
    name: '企业微信绑定',
    path: 'qw/bindingList',
    component: lazy(() => import('@/pages/qw/enterprise-business-binding/list')),
  },
    {
    name: '企业微信绑定',
    path: 'qw/bindUsers',
    component: lazy(() => import('@/pages/qw/bindUsers/list')),
  },

];

/**
 * whatsApp
 */

const whatsAppList = [
  {
    path: '/wastatistics',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/whatsApp/dataStatistics')),
  },
  {
    path: '/walist',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/whatsApp/whatsAppList')),
  },
  {
    path: '/wacuslist',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waCustomerList')),
  },
  {
    path: '/wacuslist/wadetail/:type/:userSearchInfo',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/whatsAppList/component/Detail')),
  },
  {
    path: '/wasensitiveword',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waSensitivStatic')),
  },
  {
    path: '/wasensitivesetting',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waSensitivSetting')),
  },
  {
    path: '/wschatroom/:hasmenu/:uid/:friendUid/:userId',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/chatRoom')),
  },
];

/**
 * whatsAppBusiness
 */

const whatsAppBusiness = [
  {
    path: '/waBusiness/statistics',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/whatsApp/dataStatistics')),
  },
  {
    path: '/waBusiness/userlist',
    class: true,
    exact: true,
    component: lazy(() => import('@/pages/whatsApp/whatsAppList')),
  },
  {
    path: '/waBusiness/friendlist',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waCustomerList')),
  },
  {
    path: '/waBusiness/friendlist/:type/:userSearchInfo',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/whatsAppList/component/Detail')),
  },
  {
    path: '/waBusiness/setsensitive',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waSensitivSetting')),
  },
  {
    path: '/waBusiness/sensitivestatic',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/waSensitivStatic')),
  },
  {
    path: '/waBusiness/wschatroom/:hasmenu/:uid/:friendUid/:userId',
    class: true,
    component: lazy(() => import('@/pages/whatsApp/chatRoom')),
  },
];

/**
 * 管控助手上传微信记录设置
 */

const controlWechat = [
  {
    path: '/controlWechat/uploadSettings',
    component: lazy(() => import('@/pages/controlWechat/uploadSettings')),
  },
  {
    path: '/controlWechat/staffList',
    component: lazy(() => import('@/pages/controlWechat/staffList')),
  },
  {
    path: '/controlWechat/customer',
    component: lazy(() => import('@/pages/controlWechat/customer')),
  },
  {
    path: '/controlWechat/staffList/:id',
    component: lazy(() => import('@/pages/controlWechat/staffList/detail')),
  },
  {
    path: 'weChatQualityInspection',
    component: lazy(() => import('@/pages/weChatQualityInspection/index')),
  },

];

/**
 * Messager等应用数据流程
 */

const sessionRoute = [
  {
    path: '/session/userlist/:code',
    component: lazy(() => import('@/pages/session/user-list')),
  },
  {
    path: '/session/friendlist/:code',
    component: lazy(() => import('@/pages/session/friend-list')),
  },
  {
    path: '/session/setsensitive/:type',
    component: lazy(() => import('@/pages/session/sensitive-set')),
  },
  {
    path: '/session/sensitivestatic/:code',
    component: lazy(() => import('@/pages/session/sensitive-static')),
  },
  /**
   * userId: 员工Id
   * friendId: 好友Id
   * showMenu: 是否显示菜单 1显示 0不显示
   * menuId: 菜单Id 1:聊天记录 2:群 3:快拍（朋友圈）
   * showFriendList: 1:展示 0:不展示
   */
  {
    path: '/session/chatroom/:code/:userId/:friendId/:showMenu/:menuId/:showFriendList',
    component: lazy(() => import('@/pages/session/chatroom')),
  },
];

/**
 * 邮箱管理
 */
const emailManagement = [
  {
    path: '/email/settings',
    component: lazy(() => import('@/pages/email/settings')),
  },
  {
    path: '/email/list',
    component: lazy(() => import('@/pages/email/list')),
  },
  {
    path: '/email/detail',
    component: lazy(() => import('@/pages/email/detail')),
  },

];

const routers = [
  {
    path: '/',
    component: lazy(() => import('@/layout')),
    children: [
      ...wechatDashBoard,
      ...wechatManagement,
      ...wechaRiskManagement,
      ...wechatMarketing,
      ...wechatSetting,
      ...cloudcard,
      ...qqList,
      ...dyList,
      ...whatsAppList,
      ...whatsAppBusiness,
      ...qwList,
      ...ykQwList,
      ...controlWechat,
      ...sessionRoute,
      ...emailManagement,
      {
        path: '/index',
        component: lazy(() => import('@/pages/index')),
      },
    ],
  },
  {
    path: '/iframePage',
    component: lazy(() => import('@/pages/iframePage')),
  },
  {
    path: '/login',
    component: lazy(() => import('@/pages/login')),
  },
  {
    path: '/wechattalking',
    key: 'wechattalking',
    component: lazy(() => import('@/pages/wechatTalking/index')),
  },
  {
    path: '/salewechat',
    component: lazy(() => import('@/pages/wechat-record/index')),
    children: messageList,
  },

  {
    path: '/detail',
    component: lazy(() => import('@/pages/wechat-record/groupLayout')),
    children: [
      {
        path: 'message/:wechatId/:friendId/:type',
        component: lazy(() => import('@/pages/wechat-record/components/chatwindow')),
      },
      {
        path: 'groupStatic/:wechatId/:friendId',
        class: true,
        component: lazy(() => import('@/pages/wechat-record/components/tablegroup')),
      },
    ],
  },
  {
    path: '/saleqq/:type/:qq/:friendQQ',
    class: true,
    component: lazy(() => import('@/pages/qq/qqChatRoom')),
  },
  {
    path: 'qw/customer',
    component: lazy(() => import('@/pages/qw/wechat-manage')),
    children: [
      {
        path: 'wechat-window/:userId/:toId',
        component: lazy(() => import('@/pages/qw/wechat-manage/chatComponent/index')),
      },
    ],
  },
  {
    path: 'qw/detail',
    component: lazy(() => import('@/pages/qw/wechat-manage')),
    children: [
      {
        path: 'message',
        component: lazy(() => import('@/pages/qw/wechat-manage/message')),
        children: [
          {
            path: 'wechat-window/:userId/:toId',
            component: lazy(() => import('@/pages/qw/wechat-manage/chatComponent/index')),
          },
        ],
      },
    ],
  },
  {
    path: 'controlWechatDetail',
    component: lazy(() => import('@/pages/controlWechat/message')),
    children: [
      {
        path: 'message',
        component: lazy(() => import('@/pages/controlWechat/message/component/index')),
        children: [
          {
            path: 'window/:isGroup',
            component: lazy(() => import('@/pages/controlWechat/message/component/window')),
          },
        ],
      },
      {
        path: 'window/:isGroup',
        component: lazy(() => import('@/pages/controlWechat/message/component/window')),
      },
    ],
  },
  {
    path: 'callDetail',
    component: lazy(() => import('@/pages/callDetails/index')),
  },
  {
    path: '/test-error',
    class: true,
    component: lazy(() => import('@/error')),
  },
  {
    path: '/email/detail-view/:emailId',
    component: lazy(() => import('@/pages/email/detail-view')),
  },
  {
    path: '/email/simple/:id',
    component: lazy(() => import('@/pages/email/simple-mail')),
  },
];
export default routers;
